// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import './assets/reset.css'
// import './assets/bootstrap.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'mint-ui/lib/style.css'
import './assets/pd-select.css'

import Vue from 'vue'
import FastClick from 'fastclick'
import VueLocalStorage from 'vue-localstorage'
import VueClipboard from 'vue-clipboard2'
import { sync } from 'vuex-router-sync'

import { Toast, Indicator, MessageBox } from 'mint-ui'
import App from './App.vue'
import router from './router'
import store from './store'

import './http'

var ua = navigator.userAgent.toLowerCase()
const inWx = ua.match(/micromessenger/i)
const inPC = ua.match(/window/i) || ua.match(/macintosh/i)
const inMobile = ua.match(/android/i) || navigator.userAgent.match(/iphone/i) || navigator.userAgent.match(/ipad/i)
const isIosWechatClient = ua.match(/\(i[^;]+;( U;)? cpu.+mac os x/) && inWx

// Vue.use(Toast)
Vue.use(Indicator)
Vue.use(VueLocalStorage, {
	name: 'ls'
})
Vue.use(VueClipboard)

FastClick.attach(document.body)

Vue.config.productionTip = false

sync(store, router)

router.beforeEach(function (to, from, next) {
	console.log('to', to)
	// Vue.ls.set('currentUrl', JSON.stringify({ 'name': to.name, 'params': to.params }))
	next()
})

router.afterEach(function (to) {})

Vue.prototype.joinErrorMessages = function (errors) {
	for (var key in errors) {
		if (errors.hasOwnProperty(key)) {
			var item = errors[key]
			return item.join('<br />')
		}
	}
}

Vue.prototype.handleHttpError = function (response, alert) {
	// error callback
	this.loadingHide()
	console.log(response)
	if (response.status === 422 && response.body) {
		this.toast(this.joinErrorMessages(response.body.message))
	} else if (response.status === 401 && response.body) {
		this.toast(response.body.message)
		window.location.href = response.body.login
	} else if (response.status === 403 && response.body) {
		this.toast(response.body.message)
		this.$router.replace({ name: 'Home' })
	} else if (response.status === 200) {
		if (alert && alert === true) {
			MessageBox.alert(response.body.message)
		} else {
			this.toast(response.body.message)
		}
	} else {
		this.toast('请求发生错误')
	}
}

Vue.prototype.toast = function (message) {
	Toast(message)
}

Vue.prototype.toastSuccess = function (message) {
	Toast({ message: message, iconClass: 'icon icon-success' })
}

Vue.prototype.toastError = function (message) {
	Toast({ message: message, iconClass: 'icon icon-error' })
}

Vue.prototype.loading = function (message) {
	Indicator.open(message)
}

Vue.prototype.loadingHide = function () {
	Indicator.close()
}

Vue.prototype.setPageTitle = function (title) {
	this.$store.dispatch('setPage', { 'title': title })
}

Vue.prototype.setDocTitle = function (title) {
	document.title = title
	// 对于IOS微信
	// http://blog.csdn.net/xuexiiphone/article/details/51966342
	if (!!isIosWechatClient === true) {
		const iframe = document.createElement('iframe')
		iframe.style.display = 'none'
		iframe.addEventListener('load', () => {
			setTimeout(() => {
				document.body.removeChild(iframe)
			}, 9)
		}, false)
		iframe.src = '/static/favicon.ico'
		document.body.appendChild(iframe)
	}
}

Vue.prototype.isInWeixin = function () {
	return inWx
}

Vue.prototype.isMobile = function () {
	return inMobile
}
Vue.prototype.isPC = function () {
	return inPC
}
Vue.prototype.rememberUrl = function ($route) {
	Vue.ls.set('currentUrl', JSON.stringify({ 'name': $route.name, 'params': $route.params }))
}

Vue.prototype.formatDate = function (dt, fmt) {
	var o = {
		'M+': dt.getMonth() + 1, // 月份
		'd+': dt.getDate(), // 日
		'h+': dt.getHours() % 12 === 0 ? 12 : dt.getHours() % 12, // 小时
		'H+': dt.getHours(), // 小时
		'm+': dt.getMinutes(), // 分
		's+': dt.getSeconds(), // 秒
		'q+': Math.floor((dt.getMonth() + 3) / 3), // 季度
		'S': dt.getMilliseconds() // 毫秒
	}
	var week = {
		'0': '\u65e5',
		'1': '\u4e00',
		'2': '\u4e8c',
		'3': '\u4e09',
		'4': '\u56db',
		'5': '\u4e94',
		'6': '\u516d'
	}
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (dt.getFullYear() + '').substr(4 - RegExp.$1.length))
	}
	if (/(E+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '\u661f\u671f' : '\u5468') : '') + week[dt.getDay() + ''])
	}
	for (var k in o) {
		if (new RegExp('(' + k + ')').test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
		}
	}
	return fmt
}

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	template: '<App/>',
	components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js